import { render, staticRenderFns } from "./krasOnePageDetail.vue?vue&type=template&id=6e49fd68"
import script from "./krasOnePageDetail.vue?vue&type=script&lang=js"
export * from "./krasOnePageDetail.vue?vue&type=script&lang=js"
import style0 from "./krasOnePageDetail.vue?vue&type=style&index=0&id=6e49fd68&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e49fd68')) {
      api.createRecord('6e49fd68', component.options)
    } else {
      api.reload('6e49fd68', component.options)
    }
    module.hot.accept("./krasOnePageDetail.vue?vue&type=template&id=6e49fd68", function () {
      api.rerender('6e49fd68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/krasOnePageDetail.vue"
export default component.exports